import React from 'react';

import {useCharacter} from '../../character-context';
import {isRestAction} from '../../model/action-list';
import {UsageCount} from '../usage-tracker';
import {ProcedureButton} from './procedure-button';
import {UseButton} from './use-button';

import css from '../sheet.module.css';

/** особенности, которые применяются после Короткого отдыха: восстановление ячеек и очков, замена выбора */
export const ShortRestFeatureActions: React.FC = () => {
	const {character} = useCharacter();
	const actions = character.actions.filter(isRestAction);
	if (!actions.length) return null;

	return (
		<>
			<h3 className={css.groupTitle}>Особенности после отдыха</h3>
			<ul className={css.rows}>
				{actions.map((action) => (
					<li key={action.key} className={css.row}>
						<div className={css.rowMain}>
							<span className={css.rowTitle}>{action.title}</span>
							<div className={css.rowAside}>
								<UsageCount useKey={action.key} />
								{action.procedure ? (
									<ProcedureButton action={action} procedure={action.procedure} />
								) : (
									<UseButton action={action} />
								)}
							</div>
						</div>
					</li>
				))}
			</ul>
		</>
	);
};
